import React, { useState } from 'react';
import DocumentList from '../components/DocumentList';
import DropzoneArea from '../components/DropzoneArea';
import { Toast } from '../components/ToastProgress';
import { WebSocketProvider } from '../contexts/WebSocketProvider';
import '../styles/Upload.css';


function Upload() {

    const [toasts, setToasts] = useState([]);
    
    const removeToast = (id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    };

    return (
        <>
            <div className='upload-container'>
                <DropzoneArea setToasts={setToasts}/>
                <WebSocketProvider>
                <DocumentList setToasts={setToasts} />
                </WebSocketProvider>
                <div className="toast-container">
                {toasts.map((toast) => (
                    <Toast
                    key={toast.id}
                    id={toast.id}
                    label={toast.label}
                    progress={toast.progress}
                    onClose={removeToast}
                    />
                ))}
                </div>
            </div>
        </>
    );
}

export default Upload;